import { environment } from "src/environments/environment";

export const RouteTitle = {
    ACTIVITIES: "Data Import - Activities",
    ADMIN_REPORTS: "Admin Reports",
    AGILE_ANALYZER: "Data Import - Agile Analyzer",
    CREDIT_REPORT: "Reports - Credit Report",
    REVIEWQNQ: "Review QNQ",
    DOCUMENTS: "Documents",
    EMPLOYEES: "Data Import - Employees",
    EXPENSES: "Data Import - Expenses",
    EXPENSE_SURVEY:  environment.appUrl.includes('rcnsurvey') ? "SME Expense Survey" : "Expense Survey",
    EXPENSE_SURVEY_CREATION: "Surveys - Create Expense Survey",
    EXPENSE_SURVEYS: "Surveys - Expense Surveys",
    INSIGHTS: "Insights",
    INTERVIEWS: "Interviews",
    KPMG_HOME: "Research Credit Navigator",
    MASTER_ACTIVITIES: "Master Activities",
    PROJECT_SURVEY: environment.appUrl.includes('rcnsurvey') ? "SME Project Survey" : "Project Survey",
    PROJECT_SURVEY_SETUP: "Data Import - Project Survey Setup",
    PROJECT_SURVEYS: "Surveys - Project Surveys",
    PROJECTS: "Data Import - Projects",
    BUSINESS_COMPONENT: "Data Import - Business Component",
    RECONCILIATION_SURVEY: "Surveys - Reconciliation Survey",
    RELEASE_UPDATES : "Release Updates",
    REPORTS: "Reports - QRE Reports",
    STUDIES: "Studies",
    STUDY_LANDING: "Navigator",
    SURVEYS: environment.appUrl.includes('rcnsurvey') ? "SME Surveys" : "Surveys",
    TEMPLATE_MEMO_GENERATOR: "Reports - Template Memo Generator",
    TIME_SURVEY: environment.appUrl.includes('rcnsurvey') ? "SME Time Survey" : "Time Survey",
    TIME_SURVEY_CREATION: "Surveys - Create Time Survey",
    TIME_SURVEYS: "Surveys - Time Surveys",
    TIME_TRACKING: "Data Import - Time Tracking",
    USERS: "Manage Users",
    LEGAL_ENTITY: "Data Import - Entity",
    ACTION_LOGS: "Action Logs"
};
